export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3500';

// Color pallette
export const COLOR_PRIMARY = '#0A1B89';
export const COLOR_PRIMARY_300 = '#384BA2';
export const COLOR_PRIMARY_900 = '#384BA2';
export const COLOR_SECONDARY = '#fdf6f4';
export const COLOR_SECONDARY_50 = '#EFEBE5';
export const COLOR_SECONDARY_200 = '#CEDCF4';
export const COLOR_ERROR = '#d45061';
export const COLOR_ALERT = '#F19E7A';
export const COLOR_SUCCESS = '#8AC285';
